import React, { FC } from 'react'

import { IconLaptopProps } from './IconLaptop.types'
import * as Styled from './styles/IconLaptop.style'

import { nonThemeableRules } from '../../ruleSet'

const IconLaptop: FC<IconLaptopProps> = ({
  size = nonThemeableRules.defaultSize as number as IconLaptopProps['size'],
  isResponsive = false,
}: IconLaptopProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M11.947 8.453h28.106V25.27a4 4 0 0 1-4 4H11.948a4 4 0 0 1-4-4V12.453a4 4 0 0 1 4-4v0Z'
          stroke='#0D0D0D'
          strokeLinecap='round'
          strokeMiterlimit='10'
          strokeWidth='2'
        />
        <path
          d='M36.83 29.267c1.335 0 3.383.363 4.183 2.54.8 2.178 1.425 3.778 1.78 5.113.355 1.335-.178 2.627-3.738 2.627H8.805c-3.56 0-4.092-1.292-3.737-2.627.355-1.335.98-2.933 1.78-5.113.8-2.18 2.85-2.54 4.185-2.54H36.83Z'
          stroke='#0D0D0D'
          strokeLinecap='round'
          strokeMiterlimit='10'
          strokeWidth='2'
        />
        <path d='M12.92 34.475h21.907' stroke='#E60000' strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconLaptop
